export const CONTENT_ALIGNMENT = {
  TOP: 'top',
  BOTTOM: 'bottom',
  LEFT: 'left',
  RIGHT: 'right'
};
export const HALF_WIDTH_CLASSNAME = 'col-sm-12 col-md-6 float-start';
export const FULL_WIDTH_CLASSNAME = 'col-sm-12';
